import { getKey } from './utils';

export const getCurrentContract = (contracts) => {
  let contract = {};
  if (getKey('isReseller')) {
    const contractId = getKey('selectedContractId');
    // eslint-disable-next-line eqeqeq
    contract = contracts.find(({ properties = {} }) => properties.contractNumber == contractId) || {};
  } else {
    const [e] = contracts;
    contract = e;
  }
  return contract;
};

export const getResourceLimitsForContract = (contracts) => {
  const contract = getCurrentContract(contracts);
  const { properties = {} } = contract || {};
  const { resourceLimits = {} } = properties;
  return resourceLimits;
};
